/* eslint-disable camelcase */
/* eslint-disable max-len */
import React, { Component, createRef } from 'react';
import PropTypes from 'prop-types';
import axios from 'axios';
import cx from 'classnames';
import Consent from '../common/Consent';
import Recaptcha from '../../Recaptcha';

import { PAGE_OFFER } from '../../../config/pages';
import ClarityService from '../../helpers/clarity';
import Sentry from '../../../lib/sentry';

class WebinarForm extends Component {
    constructor(props) {
        super(props);
        this.state = {
            formType: 'LemlockContactForm',
            name: '',
            surname: '',
            email: '',
            company: '',
            agreement_data: false,
            agreement_marketing: false,
            agreement_rodo: false,
            sending: false,
            error: {
                name: false,
                surname: false,
                email: false,
                company: false,
                agreement_data: false,
                agreement_marketing: false,
                agreement_rodo: false
            },
            responseType: null,
            errorType: null
        };
        this.handleChange = this.handleChange.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.handleRecaptchaError = this.handleRecaptchaError.bind(this);
        this.handleServerError = this.handleServerError.bind(this);
        this.reCaptchaRef = createRef();
    }

    handleRecaptchaError() {
        this.setState({ responseType: 'error', errorType: 'recaptcha_error' });
    }

    handleServerError() {
        this.setState({ responseType: 'error', errorType: 'server' });
    }

    handleChange(e) {
        this.setState({ [e.target.name]: e.target.type === 'checkbox' ? e.target.checked : e.target.value });
    }

    async handleSubmit(e) {
        e.preventDefault();
        let params = {};
        if (window.location.search !== '') {
            params = JSON.parse(`{"${
                decodeURI(window.location.search.substring(1))
                    .replace(/"/g, '\\"')
                    .replace(/&/g, '","')
                    .replace(/=/g, '":"')
            }"}`);
        }

        const { language } = this.props;
        const {
            name, surname, email, company, agreement_data, agreement_marketing, agreement_rodo
        } = this.state;

        let errorAll = false;
        const error = {
            name: false,
            surname: false,
            email: false,
            company: false,
            agreement_data: false,
            agreement_marketing: false,
            agreement_rodo: false
        };

        error.name = (name === '');
        errorAll = errorAll || error.name;

        error.surname = (surname === '');
        errorAll = errorAll || error.surname;

        const emailRegExp = /^[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?$/; // eslint-disable-line max-len
        error.email = !emailRegExp.test(email);
        errorAll = errorAll || error.email;

        error.company = (company === '');
        errorAll = errorAll || error.company;

        error.agreement_data = !agreement_data;
        errorAll = errorAll || error.agreement_data;

        error.agreement_rodo = !agreement_rodo;
        errorAll = errorAll || error.agreement_rodo;

        this.setState({ error });
        let token = '';
        if (errorAll === false && this.state.sending === false) {
            token = await this.reCaptchaRef.current.executeAsync();
        }

        if (errorAll === false && this.state.sending === false && token !== '') {
            this.setState({ sending: true }, () => {
                axios({
                    method: 'post',
                    url: process.env.OPPORTUNITY,
                    data: {
                        form_name: 'Webinar formularz wyceny',
                        type: this.state.formType,
                        name: name.substring(0, 50),
                        surname: surname.substring(0, 50),
                        email: email.substring(0, 100),
                        company: company.substring(0, 100),
                        agreement_data,
                        agreement_marketing,
                        agreement_rodo,
                        language,
                        slug: this.props.webinar.slug,
                        eventForm: 'webinar',
                        clarity_project_id: ClarityService.getProjectId(),
                        recaptcha: token,
                        referrer: document.referrer,
                        session_id: sessionStorage.getItem('session_id'),
                        ...params
                    },
                    headers: {
                        'X-Requested-With': 'XMLHttpRequest'
                    }
                })
                    .then((response) => {
                        ClarityService.setCorrelationId(response);
                        ClarityService.setCustomAttributes(window.location.pathname);
                        if (response.data && response.data.success) {
                            this.setState({
                                name: '',
                                surname: '',
                                email: '',
                                company: '',
                                agreement_data: false,
                                agreement_marketing: false,
                                agreement_rodo: false,
                                error: {
                                    name: false,
                                    surname: false,
                                    email: false,
                                    company: false,
                                    agreement_data: false,
                                    agreement_marketing: false,
                                    agreement_rodo: false
                                },
                                responseType: 'success',
                                errorType: null
                            });
                            this.props.openPage(PAGE_OFFER, null, null, language, true, { webinar: 'subscribed' });
                        } else {
                            this.setState({
                                error: {
                                    ...this.state.error,
                                    name: !!response.data.error_name,
                                    surname: !!response.data.error_surname,
                                    email: !!response.data.error_email,
                                    company: !!response.data.error_company,
                                    agreement_data: !!response.data.error_agreement_data,
                                    agreement_marketing: !!response.data.error_agreement_marketing,
                                    agreement_rodo: !!response.data.error_agreement_rodo
                                },
                                responseType: 'error',
                                errorType: response.data.error
                            });
                        }
                    })
                    .catch((err) => {
                        Sentry.captureException(err);
                        const { response } = err;
                        if (response.data.error === 'RECAPTCHA_LOW_SCORE' || 'RECAPTCHA_VALIDATION_ERROR') {
                            this.handleRecaptchaError();
                        } else {
                            this.handleServerError();
                        }
                        axios({
                            method: 'post',
                            url: process.env.OPPORTUNITY,
                            data: {
                                form_info: JSON.stringify({
                                    form_name: 'Webinar formularz wyceny',
                                    type: this.state.formType,
                                    name: name.substring(0, 50),
                                    surname: surname.substring(0, 50),
                                    email: email.substring(0, 100),
                                    company: company.substring(0, 100),
                                    agreement_data,
                                    agreement_marketing,
                                    agreement_rodo,
                                    language,
                                    slug: this.props.webinar.slug,
                                    eventForm: 'webinar',
                                    recaptcha: token,
                                    referrer: document.referrer,
                                    ...params
                                })
                            },
                            headers: {
                                'X-Requested-With': 'XMLHttpRequest',
                                Accept: 'application/json'
                            }
                        });
                    })
                    .finally(() => {
                        this.setState({ sending: false });
                        if (this.reCaptchaRef) this.reCaptchaRef.current.reset();
                    });
            });
        } else {
            this.setState({ responseType: 'error', errorType: 'general_error' });
        }
    }

    render() {
        const { responseType, errorType, error } = this.state;
        const { t, consents, language } = this.props;

        return (
            <form
              method="post"
              action=""
              acceptCharset="utf-8"
              className="webinar-form"
              id="webinar-form"
              onSubmit={ this.handleSubmit }
              noValidate
            >
                <div className="webinar-form-title">{ t('webinar.form.title') }</div>
                <div className="form-input" id="webinar-form-input-01">
                    <input
                      type="text"
                      name="name"
                      id="webinar-form-input-field-01"
                      value={ this.state.name }
                      placeholder={ `${ t('webinar.form.placeholder.name') } *` }
                      className={ cx({ error: error.name }) }
                      onChange={ this.handleChange }
                      maxLength={ 50 }
                    />
                </div>
                <div className="form-input" id="webinar-form-input-02">
                    <input
                      type="text"
                      name="surname"
                      id="webinar-form-input-field-02"
                      value={ this.state.surname }
                      placeholder={ `${ t('webinar.form.placeholder.surname') } *` }
                      className={ cx({ error: error.surname }) }
                      onChange={ this.handleChange }
                      maxLength={ 50 }
                    />
                </div>
                <div className="form-input" id="webinar-form-input-03">
                    <input
                      type="email"
                      name="email"
                      id="webinar-form-input-field-03"
                      value={ this.state.email }
                      placeholder={ `${ t('webinar.form.placeholder.email') } *` }
                      className={ cx({ error: error.email }) }
                      onChange={ this.handleChange }
                      maxLength={ 100 }
                    />
                </div>
                <div className="form-input" id="webinar-form-input-04">
                    <input
                      type="text"
                      name="company"
                      id="webinar-form-input-field-04"
                      value={ this.state.company }
                      placeholder={ `${ t('webinar.form.placeholder.company') } *` }
                      className={ cx({ error: error.company }) }
                      onChange={ this.handleChange }
                      maxLength={ 100 }
                    />
                </div>
                <div className="form-checkbox" id="webinar-form-checkbox-01">
                    <input
                      type="checkbox"
                      name="agreement_data"
                      id="webinar_form_input_agreement_data"
                      checked={ this.state.agreement_data }
                      onChange={ this.handleChange }
                    />
                    <label htmlFor="webinar_form_input_agreement_data" className={ cx({ error: error.agreement_data }) }/>
                    <Consent t={ t } required content={ consents.contact.text } title={ consents.contact.label }/>
                </div>
                <div className="form-checkbox" id="webinar-form-checkbox-02">
                    <input
                      type="checkbox"
                      name="agreement_marketing"
                      id="webinar_form_input_agreement_marketing"
                      checked={ this.state.agreement_marketing }
                      onChange={ this.handleChange }
                    />
                    <label htmlFor="webinar_form_input_agreement_marketing" className={ cx({ error: error.agreement_marketing }) }/>
                    <Consent t={ t } content={ consents.marketing.text } title={ consents.marketing.label }/>
                </div>
                <div className="form-checkbox" id="webinar-form-checkbox-03">
                    <input
                      type="checkbox"
                      name="agreement_rodo"
                      id="webinar_form_input_agreement_rodo"
                      checked={ this.state.agreement_rodo }
                      onChange={ this.handleChange }
                    />
                    <label htmlFor="webinar_form_input_agreement_rodo" className={ cx({ error: error.agreement_rodo }) }/>
                    <Consent t={ t } required content={ consents.rodo.text } title={ consents.rodo.label }/>
                </div>
                {
                    errorType === 'recaptcha_error' ?
                        <div className="form-button form-button-blue" id="webinar-form-button-refresh-container">
                            <button id="webinar-form-button-refresh" onClick={ () => window.location.reload() }>{ t('webinar.form.label.refresh') }</button>
                        </div> :
                        responseType !== 'success' &&
                        <div className="form-button form-button-blue" id="webinar-form-button-submit-container">
                            <button
                              disabled={ this.state.sending }
                              type="submit"
                              id="webinar-form-button-submit"
                            >{ t('webinar.form.label.button') }
                            </button>
                        </div>
                }
                {
                    responseType && (responseType === 'success' ?
                        <div className={ cx('form-message', responseType) } id={ cx('form-message', responseType) }>
                            <span>{ t(`form.message.${ responseType }`) }</span>
                        </div>
                        :
                        <div className={ cx('form-message', 'error') } id={ cx('form-message', 'error') }>
                            <span>{ t(`form.message.${ errorType }`) }</span>
                        </div>
                    )
                }
                <Recaptcha ref={ this.reCaptchaRef } language={ language }/>
            </form>
        );
    }
}

WebinarForm.propTypes = {
    t: PropTypes.func.isRequired,
    openPage: PropTypes.func.isRequired,
    language: PropTypes.string.isRequired,
    webinar: PropTypes.shape().isRequired,
    consents: PropTypes.objectOf(Object).isRequired
};

export default WebinarForm;



// WEBPACK FOOTER //
// ./src/components/content/webinar/WebinarForm.jsx